<script>
  import MarkdownBox from './MarkdownBox.svelte';
  import LineLink from '../common/LineLink.svelte';
  import Button from '../common/Button.svelte';

  export let value;
  export let page;
  export let lang = undefined;
  export let user;

  const i18n = {
    editPage: {
      cs: 'Upravit stránku',
      en: 'Edit page',
    },
  };
</script>

{#if value.content[lang] || value.label[lang] || user}
  <div class='page-box'>
    {#if value.content[lang]}
      <div class='page-box-content'>
        <MarkdownBox value={value.content[lang]}/>
      </div>
    {/if}

    {#if value.label[lang]}
      <div class='page-box-label'>
        <LineLink value={value.label[lang]} link={value.link}/>
      </div>
    {/if}

    {#if user}
      <div class='page-box-admin'>
        <Button value={i18n.editPage[lang]} icon='edit' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
          onClick={() => { window.location.href = `./#/admin/pages/${page}`; }}/>
      </div>
    {/if}
  </div>
{/if}

<style>
  .page-box {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }
</style>
